<template>
  <div class="">
    <div class="flex gap-x-4 flex-row items-center pb-3">
      <div class="flex items-center justify-center">
        <!-- Outer Circle -->
        <div class="w-2 h-2 bg-blue-500 rounded-full flex items-center justify-center ">
          <!-- Inner Circle -->
          <div class="w-1 h-1 bg-white rounded-full "></div>
        </div>
      </div>
      <h3 class="text-base text-gray-900" dir="ltr">{{ $t('comp_rule_1') }}</h3>
    </div>
    <div class="flex gap-x-4 items-center pb-3">
      <div class="flex items-center justify-center">
        <!-- Outer Circle -->
        <div class="w-2 h-2 bg-blue-500 rounded-full flex items-center justify-center ">
          <!-- Inner Circle -->
          <div class="w-1 h-1 bg-white rounded-full "></div>
        </div>
      </div>
      <h3 class="text-base text-gray-900">{{ $t('comp_rule_2') }}</h3>
    </div>
      <div class="flex gap-x-4 items-center pb-3 relative">
        <div class="flex items-center justify-center absolute md:relative left-0 bottom-11 md:inset-0">
          <!-- Outer Circle -->
          <div class="w-2 h-2 bg-blue-500 rounded-full flex items-center justify-center">
            <!-- Inner Circle -->
            <div class="w-1 h-1 bg-white rounded-full"></div>
          </div>
        </div>
        <h3 class="text-base text-gray-900 md:pl-0 pl-6">
         {{ $t('comp_rule_3_main') }}
         <span class="italic block md:inline"> {{ $t('comp_rule_3_sub') }}</span>
        </h3>
      </div>

    <div class="flex gap-x-4 items-center pb-3">
      <div class="flex items-center justify-center">
        <!-- Outer Circle -->
        <div class="w-2 h-2 bg-blue-500 rounded-full flex items-center justify-center">
          <!-- Inner Circle -->
          <div class="w-1 h-1 bg-white rounded-full"></div>
        </div>
      </div>
      <h3 class="text-base text-gray-900">{{ $t('comp_rule_4') }}</h3>
    </div>
    <div class="flex gap-x-4 items-center pb-3">
      <div class="flex items-center justify-center">
        <!-- Outer Circle -->
        <div class="w-2 h-2 bg-blue-500 rounded-full flex items-center justify-center">
          <!-- Inner Circle -->
          <div class="w-1 h-1 bg-white rounded-full"></div>
        </div>
      </div>
      <h3 class="text-base text-gray-900">{{ $t('comp_rule_5') }}</h3>
    </div>
  </div>
</template>

<script>
export default {
  name: 'rules',
  data() {
    return {}
  },
  props: {
    item: Object
  },
  watch: {},
  computed: {},
  methods: {}
}
</script>

